module.exports = __webpack_public_path__ + "static/media/residenziale-vendita.7a54639a.jpg";